import { Link } from 'react-router';
import { Image } from '../../../common/components/Image';

function Logo() {
  return (
    <Link to="/" className="header__logo">
      <Image src="/site-logo.webp" alt="Logo" />
    </Link>
  );
}

export default Logo;
